import { USER_KEY } from "./constants";

const getToken = () => {
    let user;
    if (localStorage.getItem(USER_KEY)) {
        user = JSON.parse(localStorage.getItem(USER_KEY));
    }
    return user ? `Bearer fake-jwt-token ${user.jwtToken}` : "";
}

export const getAxiosRequestConfig = () => {
    return {
        headers: {
            'Authorization': getToken()
        }
    }
}

// export const atob = (inputString) => {
//     return Buffer.from(inputString, 'binary').toString('base64');
// };

// export const btoa = (inputString) => {
//     return Buffer.from(inputString, 'base64').toString('binary');
// };

